"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voidSigner = exports.addr0 = void 0;
const ethers_1 = require("ethers");
exports.addr0 = ethers_1.constants.AddressZero;
exports.voidSigner = new ethers_1.VoidSigner(exports.addr0);
